exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/babel-polyfill/~/core-js/modules/_object-gops.js
// module id = TiM2
// module chunks = 0 3